import { deleteJson, getJson, postJson } from './client'
import type { CalendarRangeView, CalendarView, MeetingsView } from '../types/calendar'
import type { JobView } from '../types/voice'

// The calendar connector: connect a Microsoft 365 calendar; every read of it is the calendar-sync job.
const cal = (spoke: string) => `/api/spokes/${encodeURIComponent(spoke)}/scout/calendar`

export const calendarApi = {
  view: (spoke: string) => getJson<CalendarView>(cal(spoke)),
  connect: (spoke: string) => postJson<{ authorizeUrl: string; state: string }>(`${cal(spoke)}/connect`, {}),
  sync: (spoke: string) => postJson<JobView>(`${cal(spoke)}/sync`, {}),
  disconnect: (spoke: string) => deleteJson<void>(cal(spoke)),
  meetings: (spoke: string) => getJson<MeetingsView>(`${cal(spoke)}/meetings`),
  /** The meetings in [from, to), each with its facts — the one read behind the month, week, and agenda views. */
  range: (spoke: string, from: Date, to: Date) => getJson<CalendarRangeView>(`${cal(spoke)}/range`, { from: from.toISOString(), to: to.toISOString() }),
}
